export default __webpack_public_path__ + "static/media/rendement.428fcf90.svg";